export default "__VITE_ASSET__Cm7KdsVF__"